module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames0-ac56dd3354d04ec73d23ef6894ab8637.webp";